<template>
    <div class="payment-express" ref="rootElement">
        <div class="payment-express__methods">
            <GooglePayButton
                v-show="isGooglePayEnabled"
                :on-g-p-cancel="onGPCancel"
                :on-g-p-click="onGPClick"
                :on-g-p-error="onGPError"
                :on-g-p-load-payment-data="onGPLoadPaymentData"
                :on-g-p-ready-to-pay-change="onGPReadyToPayChange"
            />
            <apple-pay-button
                v-show="isApplePayEnabled"
                buttonstyle="black" 
                type="plain" 
                locale="pt-BR"
                @click="$emit('applePayClick')"
            />

            <!-- Button for localhost -->
            <!-- <button
                v-show="!isApplePayEnabled"
                class="apple-pay-button--dev"
                @click="$emit('applePayClick')"
            >
                Apple Pay Test
            </button> -->
        </div>

        <Divider />
    </div>
</template>

<script>

import GooglePayButton from '@/components/GooglePayButton';
import Divider from '@/components/Divider';

export default {
    props: {
        isGooglePayEnabled: {
            type: Boolean,
            default: false
        },
        onGPCancel: {
            type: Function,
            default: null,
        },
        onGPClick: {
            type: Function,
            default: null,
        },
        onGPError: {
            type: Function,
            default: null,
        },
        onGPLoadPaymentData: {
            type: Function,
            default: null,
        },
        onGPReadyToPayChange: {
            type: Function,
            default: null,
        },
        isApplePayEnabled: {
            type: Boolean,
            default: false
        },
    },

    components: {
        GooglePayButton,
        Divider
    },
};
</script>

<style lang="scss">
.payment-express {

    &__subtitle {
        font-size: 14px;
        font-weight: 600;
        line-height: 16px;
        color: #2F363E;
        margin-bottom: 20px;
    }

    &__description {
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        color: #5C6A7B;
        margin-top: 16px;
    }

    &__methods {
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media screen and (min-width: 1025px) {
            flex-direction: row;
        }

        & > * {
            width: 100%;
        }
    }

    apple-pay-button {
        --apple-pay-button-width: 100%;
        --apple-pay-button-height: 48px;
        --apple-pay-button-border-radius: 8px;
        --apple-pay-button-padding: 0px 0px;
        --apple-pay-button-box-sizing: border-box;

        @media screen and (min-width: 1025px) {
            
        }
    }

    .apple-pay-button--dev {
        width: 100%;
        height: 48px;
        border-radius: 8px;
    }
}
</style>
